import { c as _c } from "react/compiler-runtime";
import { useAuth } from "../../hooks/use-auth";
import RequestResetPasswordCard from "./RequestResetPasswordCard";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RequestResetPasswordView(t0) {
  const $ = _c(11);
  const {
    authClient,
    onSuccess,
    onBackToSignIn,
    statusMessage,
    onStatusMessageAction
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    requestPasswordReset,
    isUpdating
  } = useAuth(t1);
  let t2;
  if ($[2] !== onSuccess || $[3] !== requestPasswordReset) {
    t2 = async email => {
      const response = await requestPasswordReset(email);
      if (response.success && onSuccess) {
        onSuccess();
      }
      return response;
    };
    $[2] = onSuccess;
    $[3] = requestPasswordReset;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleRequestReset = t2;
  let t3;
  if ($[5] !== handleRequestReset || $[6] !== isUpdating || $[7] !== onBackToSignIn || $[8] !== onStatusMessageAction || $[9] !== statusMessage) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "bg-background sm:flex sm:grow sm:items-start sm:justify-center sm:px-4 lg:px-0",
      children: /*#__PURE__*/_jsx(RequestResetPasswordCard, {
        onSubmit: handleRequestReset,
        onBackToSignIn: onBackToSignIn,
        loading: isUpdating,
        statusMessage: statusMessage,
        onStatusMessageAction: onStatusMessageAction
      })
    });
    $[5] = handleRequestReset;
    $[6] = isUpdating;
    $[7] = onBackToSignIn;
    $[8] = onStatusMessageAction;
    $[9] = statusMessage;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}